export { ActivitiesMessageComponent } from './activities-message.component';



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/activities/activities-message/index.ts